import instanceAPI from 'services/apis/axiosconfig';

const axiosConfig = {
  withCredentials: true,
};

export const getSession = () => {
  const request = instanceAPI.get('/private/get-personal-data', axiosConfig);
  return request.then((res) => res).catch((error) => error);
};
